/**
 * 4-step progress indicator for the Upload Wizard.
 *
 * Step labels match `feature-spec.md` §2.5 verbatim.
 */

import React from 'react';

import { cn } from '../../../../../lib/utils';

export type WizardStep = 1 | 2 | 3 | 4;

const STEPS: ReadonlyArray<readonly [WizardStep, string]> = [
  [1, 'Upload CSV'],
  [2, 'Select Channel'],
  [3, 'Config'],
  [4, 'Review & Confirm'],
];

interface Props {
  step: WizardStep;
}

const WizardStepIndicator: React.FC<Props> = ({ step }) => (
  <ol
    className="flex flex-wrap items-center gap-x-3 gap-y-2 text-[12px]"
    data-testid="wizard-step-indicator"
  >
    {STEPS.map(([n, label]) => {
      const isActive = n === step;
      const isComplete = n < step;
      return (
        <li
          key={n}
          className={cn(
            'flex items-center gap-1.5',
            isActive ? 'font-semibold text-foreground' : 'text-muted-foreground',
          )}
          aria-current={isActive ? 'step' : undefined}
          data-step={n}
          data-active={isActive}
        >
          <span
            className={cn(
              'flex h-5 w-5 items-center justify-center rounded-full border text-[10px] font-semibold',
              isActive
                ? 'border-primary bg-primary text-primary-foreground'
                : isComplete
                  ? 'border-emerald-600 bg-emerald-600 text-white'
                  : 'border-border bg-card',
            )}
          >
            {n}
          </span>
          {label}
        </li>
      );
    })}
  </ol>
);

export default WizardStepIndicator;
